<div class="row">
    <!-- Welcome Card -->
    <div class="col-12 mb-4">
        <div class="card p-4">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h2 class="fw-bold" style="color: var(--primary-color);">Welcome to HexaDash Logic!</h2>
                    <p class="text-muted">manage your companies, stores, and customers with ease.</p>
                </div>
                <!-- <button class="btn btn-primary">
                    <i class="bi bi-plus-lg me-2"></i> Create New Schedule
                </button> -->
            </div>
        </div>
    </div>

    <!-- Stats Cards -->
    <div class="col-md-3 mb-4">
        <div class="card p-3">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <h6 class="text-muted text-uppercase">Total Companies</h6>
                    <h3 class="fw-bold">100+</h3>
                </div>
                <div class="icon-box bg-light text-primary rounded p-2">
                    <i class="bi bi-building fs-4"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-3 mb-4">
        <div class="card p-3">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <h6 class="text-muted text-uppercase">Total Stores</h6>
                    <h3 class="fw-bold">30,825</h3>
                </div>
                <div class="icon-box bg-light text-info rounded p-2">
                    <i class="bi bi-shop fs-4"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-3 mb-4">
        <div class="card p-3">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <h6 class="text-muted text-uppercase">Total Customers</h6>
                    <h3 class="fw-bold">$30,825</h3>
                </div>
                <div class="icon-box bg-light text-warning rounded p-2">
                    <i class="bi bi-people fs-4"></i>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-3 mb-4">
        <div class="card p-3">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <h6 class="text-muted text-uppercase">New Customers</h6>
                    <h3 class="fw-bold">30,825</h3>
                </div>
                <div class="icon-box bg-light text-success rounded p-2">
                    <i class="bi bi-person-plus fs-4"></i>
                </div>
            </div>
        </div>
    </div>
</div>